import { render, staticRenderFns } from "./dogTitle.vue?vue&type=template&id=1a025c38&scoped=true&"
import script from "./dogTitle.vue?vue&type=script&lang=js&"
export * from "./dogTitle.vue?vue&type=script&lang=js&"
import style0 from "./dogTitle.vue?vue&type=style&index=0&id=1a025c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a025c38",
  null
  
)

export default component.exports